import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { Product } from '../../types/Product';
import { highlightSearchTerm } from '../../utils/text';

interface ProductSearchResultProps {
  product: Product;
  searchTerm: string;
  onSelect: () => void;
}

export const ProductSearchResult: React.FC<ProductSearchResultProps> = ({
  product,
  searchTerm,
  onSelect
}) => {
  const highlightedName = highlightSearchTerm(product.display_name, searchTerm);
  const highlightedCategory = highlightSearchTerm(product.category_name, searchTerm);

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      onClick={onSelect}
      className="w-full flex items-center gap-3 p-2 hover:bg-orange-50 transition-colors"
    >
      <img
        src={product.thumbnail}
        alt={product.display_name}
        className="w-12 h-12 object-cover rounded-lg"
      />
      <div className="flex-1 text-left">
        <p 
          className="font-medium line-clamp-1"
          dangerouslySetInnerHTML={{ __html: highlightedName }}
        />
        <p 
          className="text-sm text-gray-500 line-clamp-1"
          dangerouslySetInnerHTML={{ __html: highlightedCategory }}
        />
      </div>
      <div className="flex items-center gap-2">
        <span className="text-orange-600 font-semibold">
          {product.current_price.toFixed(2)}€
        </span>
        <Plus size={16} className="text-orange-500" />
      </div>
    </motion.button>
  );
};